import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Toast from '../../../../atoms/Toast/Toast'
import TDDashboardTabs from '../../../../components/TDDashboardTabs/TDDashboardTabs'
import PageWithHeader from '../../../../layouts/pageWithHeader/PageWithHeader'
import TableDashboard from '../../../../view/tableDashboard/TableDashboard'
import ConfirmDeleteDialog from '../../schools/Edit/tabs/dialogs/ConfirmDeleteDialog'
import CreateNewUserDialog from './Dialogs/CreateNewUserDialog'
import useUsers from './useUsers'
import './users.scss'

const Users = () => {
  const {
    tabs,
    total,
    users,
    roles,
    offset,
    columns,
    pageSize,
    isLoading,
    totalPages,
    currentPage,
    onChangePage,
    showToast,
    toastMessage,
    setShowToast,
    onClickOnUser,
    onClickOnCreate,
    onCreateNewUser,
    isCreateNewUserDialogOpen,
    onCloseCreateNewUserDialog,
    onSearch,
    onDeleteUser
  } = useUsers()

  const { t } = useTranslation()

  const [itemToDelete, setItemToDelete] = useState(null)
  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    useState(false)

  return (
    <PageWithHeader left={<TDDashboardTabs tabs={tabs} currentTab={'users'} />}>
      <TableDashboard
        disableFilters
        filters={[
          {
            id: 'status',
            key: 'status',
            title: 'Status',
            type: 'radio',
            options: [
              { label: 'Active', value: 'active' },
              { label: 'Inactive', value: 'inactive' }
            ]
          }
        ]}
        onSearch={(value) => {
          onSearch(value)
        }}
        onFilter={() => {}}
        tableData={users}
        onRowClick={onClickOnUser}
        tableColumns={columns}
        totalEntries={total}
        onClickOnCreate={onClickOnCreate}
        singleEntryLabel='user'
        pluralEntryLabel='users'
        searchInputPlaceholder='Search users'
        numberOfFilters={0}
        isTableDataLoading={isLoading}
        showPagination={true}
        totalPages={totalPages}
        currentPage={currentPage}
        onChangePage={onChangePage}
        options={[
          {
            icon: <BorderColorOutlinedIcon />,
            label: t('edit'),
            onClick: onClickOnUser
          },
          {
            icon: <DeleteOutlineIcon />,
            label: t('delete'),
            onClick: (user) => {
              setItemToDelete(user)
              setIsConfirmDeleteDialogOpen(true)
            },
            labelStyle: 'danger'
          }
        ]}
      />
      <CreateNewUserDialog
        roles={roles}
        onSubmit={onCreateNewUser}
        isOpen={isCreateNewUserDialogOpen}
        onClose={onCloseCreateNewUserDialog}
      />

      <ConfirmDeleteDialog
        item={itemToDelete}
        isOpen={isConfirmDeleteDialogOpen}
        onClose={() => {
          setItemToDelete(null)
          setIsConfirmDeleteDialogOpen(false)
        }}
        onConfirm={() => {
          onDeleteUser(itemToDelete)
          setItemToDelete(null)
          setIsConfirmDeleteDialogOpen(false)
        }}
        itemToBeDeletedName={itemToDelete?.name}
      >
        <div className='users__delete-dialog'>
          <table className='users__delete-dialog-table'>
            <tr>
              <td className='users__delete-dialog-table-row-label'>Role</td>
              <td className='users__delete-dialog-table-row-value'>
                {itemToDelete?.role_name}
              </td>
            </tr>
            <tr>
              <td className='users__delete-dialog-table-row-label'>Username</td>
              <td className='users__delete-dialog-table-row-value'>
                {itemToDelete?.username}
              </td>
            </tr>
            <tr>
              <td className='users__delete-dialog-table-row-label'>Schools</td>
              <td className='users__delete-dialog-table-row-value users__delete-dialog-schools-list'>
                {itemToDelete?.schools?.length > 0 ? (
                  itemToDelete?.schools?.map((school) => (
                    <div key={school.id}>{school.name}</div>
                  ))
                ) : (
                  <div className='users__delete-dialog-schools-list-empty'>
                    This user is not assigned to any school
                  </div>
                )}
              </td>
            </tr>
          </table>
        </div>
      </ConfirmDeleteDialog>

      {showToast && (
        <Toast
          handleShowToast={setShowToast}
          type={toastMessage.type}
          text={toastMessage.text}
        />
      )}
    </PageWithHeader>
  )
}

export default Users
